import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import { withRouter } from "react-router";
import classnames from "classnames";

import { Button } from "@lifepay/rc-ui-toolkit";

// import Badge from "components/visual/Badge";
// import Labeled from "components/visual/Labeled";
// import Details from "components/visual/Details";

import styles from "./Merchant.m.scss";

function Merchant(props) {
  const { theme, item, history, basePath } = props;
  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.summary)}>
        <div>{item.id}</div>
        <div>{item.merchantName}</div>
        <div>{item.address}</div>
        <div>{item.city}</div>
        <div>{item.zipCode}</div>
        <div>
          <Button
            theme={{ wrapper: theme.button }}
            size={"small"}
            type={"alt"}
            onClick={() => {
              history.push({
                pathname: `${basePath}/terminals`,
                search: `?merchant-id=${item.id}`,
                state: {
                  routerStateQuery: {
                    merchantId: item.id,
                  },
                },
              });
            }}
          >
            {"Терминалы"}
          </Button>
        </div>
      </div>
    </div>
  );
}

Merchant.displayName = "Merchant";

Merchant.propTypes = {
  theme: PropTypes.object,
  item: PropTypes.object,
  history: PropTypes.object,
  basePath: PropTypes.string,
};

Merchant.defaultProps = {};

export default withRouter(themr("@lifepay/Merchant", styles)(Merchant));



// WEBPACK FOOTER //
// ./src/components/list-items/Merchant/Merchant.js